// extracted by mini-css-extract-plugin
export default {"container":"KMWa9FNzmw4MPOygVPRK"};